  import { ErrorHandler, Inject, Injectable } from '@angular/core';
import {
  AngularPlugin
} from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Router } from '@angular/router';
import { investorPortalSettings, PORTAL_SETTINGS } from '../../settings';

@Injectable({ providedIn: 'root' })
export class InsightsService {
  private readonly angularPlugin = new AngularPlugin();

  private appInsights = new ApplicationInsights({
    config: {
      samplingPercentage : 100,
      instrumentationKey: this.settings.appInsightsInstrumentationKey,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      // <any> is required to avoid types compatibility issues
      extensions: [this.angularPlugin as any],
      extensionConfig: {
        [this.angularPlugin.identifier]: {
          router: this.router,
          errorServices: [new ErrorHandler()],
        },
      },
    }
  });

  constructor(
    private router: Router,
    @Inject(PORTAL_SETTINGS) protected settings: investorPortalSettings
  ) {
    if (this.settings.appInsightsInstrumentationKey === null ||
      this.settings.appInsightsInstrumentationKey.match(/^ *$/) !== null) {
      this.appInsights.config.disableTelemetry = true;
      return;
    }
    this.appInsights.loadAppInsights();
    this.appInsights.trackPageView();

    const telemetryInitializer = (envelope) => {
      envelope.tags['ai.cloud.role'] = 'corpro-investor-frontend';
    };

    this.appInsights.addTelemetryInitializer(telemetryInitializer);
  }

  logPageView(name?: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }

  trackUserId(userId: string, accountId: string) {
    if (this.appInsights.config.disableTelemetry) {
      return;
    }

    this.appInsights.setAuthenticatedUserContext(userId, accountId, true);
  }
}
